<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">페럼홀</h3>
      </div>
      <div class="txt">
        <h4 class="fs-50 fMTP-EB main_color pdb30">FERRUM HALL</h4>
        <p class="lh30 pdb50">
          "페럼홀 방문을 진심으로 환영합니다."
          <br />저희 비즈니스센터는 2호선 을지로 입구역에 위치해 있어 접근성이 좋으며, 소회의실(6~7인실)과 대강당(220석)까지
          다양한 규모의 회의실을 보유하고 있으며 대강당의 경우 대규모 회의, 강당, 뮤지컬 연주회 등 문화공연을 편안하게 즐길
          수 있습니다. 또한 케이터링 서비스를 통해 간단히 음료와 간식을 주문할 수 있습니다.
        </p>
        <p class="pdt10">
          <img :src="require('./../../assets/img/sub/02/0203_01.png')" />
        </p>
        <p class="pdt20 pdb40">
        <!--20210421 
          <iframe
            width="825px"
            height="467px"
            src="https://serviceapi.nmv.naver.com/flash/convertIframeTag.nhn?vid=0A524191E8F9B4E17EA6A35D3865FC625D11&outKey=V1235b05e1c7319ddfdcc0fc3b833223888e91c6de27a89fd54890fc3b833223888e9&width=544&height=306"
            frameborder="0"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen="allowfullscreen"
          ></iframe> -->
        </p>

        <div class="pdt40 pdb20">
          <router-link to="/Biz/Reserve">
            <button class="btn_link">대관예약 바로가기</button>
          </router-link>
        </div>
        <!-- <h5 class="pdt50">대관문의</h5>
        <ul class="type_w33 pdt30">
          <li>
            <b>전화번호</b>02 - 6353 - 8558
          </li>
          <li>
            <b>휴대폰</b>010 - 7502 - 2955
          </li>
          <li>
            <b>이메일</b>ferrumhall@dongkuk.com
          </li>
        </ul>-->
      </div>

      <div class="txt luxteel-txt">
        <h4 class="fs-50 fMTP-EB main_color pdb30">cafe <img :src="require('./../../assets/img/sub/02/luxteel_logo.png')" /></h4>
        <p class="lh30 pdb50">
          카페 럭스틸은 신선하고 풍부한 커피의 맛과 향으로 고객 만족을 위해 최선을 다하고 있습니다. 소비자들의 기호를 빠르게 캐치하여, 대중적 선호가 높은 메뉴를 개발하고 출시합니다.
          이렇게 트렌디한 음료를 저렴한 가격에 맛 볼 수 있다는 것이 카페 럭스틸의 장점입니다.
        </p>
        <p class="luxteel-img">
          <img :src="require('./../../assets/img/sub/02/0203_02.png')" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "FerrumTower.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub02/FerrumTower.vue